import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

import { NormasService } from '../_services/normas.service';
import { Area } from '../_models/area.model';
declare var jQuery:any;


@Component({
  selector: 'formularioarea',
  templateUrl: 'formularioarea.template.html',
  //providers:  [PreguntasService]
})
export class FormularioAreaComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() idbloque: any;
  @Input() idarea: any;

  @Output() onChangeArea = new EventEmitter<any>();

  emisorcambio: any = {
    anadir: false,
    change: false
  }

  subscription: Subscription;
  id_area: number;
  id_bloque: number;

  listabloques: any[];

  area: Area;


  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.getListaBloques();

  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['idarea']){
      this.id_area = changes['idarea'].currentValue;
    }
    if (changes['idbloque']){
      this.id_bloque = changes['idbloque'].currentValue;
    }
    this.getArea(this.id_area);
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  onSubmit(formulario: NgForm, event: Event){
    event.preventDefault;
    //console.log(formulario);
    let area: any;

    area = {
      abr: this.area.abr,
      descripcion: this.area.descripcion,
      id_bloque: this.area.id_bloque,
      id_area: this.area.id_area
    };

    //console.log(JSON.stringify(norma));

    this.normasService.setArea(area).subscribe(
      data => {
        if (data){

          let al: any = {
            "texto" : "Area guardada",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateArea(data);
        }
      }
    );
  }

  guardarAnadir(formulario: NgForm, event: Event){
    this.emisorcambio.anadir = true;
    this.onSubmit(formulario,event);
  }

  guardar(formulario: NgForm, event: Event){
    this.emisorcambio.anadir = false;
    this.onSubmit(formulario,event);
  }

  getArea(id_area){

    this.area = new Area();

    if (id_area != 0){

      this.normasService.getArea(id_area).subscribe(
        data => {
          if (data){
            if (id_area != 0){

              this.area.abr = data.json().area.abr;
              this.area.descripcion = data.json().area.descripcion;
              this.area.id_bloque = data.json().area.id_bloque;
              this.area.id_area = data.json().area.id_area;

            }else{
              this.area.id_bloque = this.id_bloque;
            }
          }

        }
      );

    }else{
      this.area.id_bloque = this.id_bloque;
      this.area.id_area = this.id_area;
    }
  }

  updateArea(data){

    this.area = new Area();

    this.area.abr = data.json().area.abr;
    this.area.descripcion = data.json().area.descripcion;
    this.area.id_bloque = data.json().area.id_bloque;
    this.area.id_area = data.json().area.id_area;

    this.actualizaPadre();

  }

  actualizaPadre(){
    //this.onChangeArea.emit(true);
    this.onChangeArea.emit(this.emisorcambio);
    if (this.emisorcambio.anadir){
      this.getArea(0);
    }
  }

  getListaBloques(){
    this.normasService.getListaBloques().subscribe(
      data => {
        if (data){
          this.listabloques = data.json().lista;
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/inventarionormas/formularioarea.component.ts